module.exports = __webpack_public_path__ + "static/media/twitter.8589489a.svg";